module.exports = require('./editorScript').editorScript;
